import React, { ComponentProps } from 'react'
import { Textarea, TextareaProps } from '../ui/textarea'
import InputGroup, { InputGroupProps } from './input-group'
import { cn } from '../../lib/utils'

export type TextAreaInputProps = TextareaProps & {
    inputGroupProps?: InputGroupProps,
} 

function TextAreaInput({
    inputGroupProps,
    ...props
}: TextAreaInputProps) {
    return (
        <InputGroup {...inputGroupProps}>
            <Textarea 
                {...props}
                className={cn(
                    "transition-colors duration-200",
                    inputGroupProps?.isDirty && "border-[#9c27b0] focus:border-[#9c27b0] focus:ring-[#9c27b0]/20 shadow-sm",
                    props.className
                )}
            />
        </InputGroup>
    )
}

export default TextAreaInput